"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_dom_1 = __importDefault(require("react-dom"));
var lib_1 = require("@syl-editor/lib");
var toolbar_loader_1 = require("@syl-editor/lib/dist/lib/modules/toolbar/toolbar-loader");
var toolbar_loader_2 = require("@syl-editor/lib/dist/lib/modules/toolbar/inline/toolbar-loader");
var toolbar_1 = require("../modules/toolbar");
var main_1 = require("./main");
var table_1 = require("@syl-editor/lib/dist/lib/formats/table");
var inline_1 = require("../modules/toolbar/render/inline");
var SylWrapper = /** @class */ (function (_super) {
    __extends(SylWrapper, _super);
    function SylWrapper() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            value: null,
            locale: {}
        };
        _this.adapter = null;
        _this.getAdapter = function (adapter) {
            _this.adapter = adapter;
            _this.props.getAdapter && _this.props.getAdapter(adapter);
            setTimeout(function () {
                _this.setState({
                    locale: {
                        link: {
                            tooltip: 'tooltip',
                            editLinkTitle: 'editLinkTitle',
                            insertLinkTitle: 'insertLinkTitle',
                            textPlaceholder: 'textPlaceholder',
                            linkPlaceholder: 'linkPlaceholder',
                            cancelText: 'cancelText',
                            okText: 'okText'
                        }
                    }
                });
            }, 2000);
        };
        return _this;
    }
    SylWrapper.prototype.render = function () {
        return (react_1.default.createElement(main_1.SylEditor, { key: "syl-editor", locale: this.state.locale, getAdapter: this.getAdapter, placeholder: '请输入', spellCheck: false, onError: function (err) {
                console.log('got error');
                console.error(err);
            }, config: this.props }));
    };
    return SylWrapper;
}(react_1.default.PureComponent));
var getOption = function (props) {
    return {
        Plugins: __spreadArrays(getSylPlugins(props.pluginProps), [
            {
                plugin: table_1.TablePlugin,
                controllerProps: {
                    button: {
                        activeColor: '#FF0F0F',
                        trigger: 'click'
                    },
                    columnResize: { handleWidth: 5, cellMinWidth: 24 },
                    table: {
                        allowTableNodeSelection: false,
                        defaultCellWidth: 100,
                        useTableHeader: false
                    }
                }
            }
        ]),
        Modules: __assign({}, getModulesOption(props)),
        onChange: props.onChange,
        getAdapter: function (sylApi) { }
    };
};
function render(el, props) {
    var adapter = null;
    var option = getOption(props);
    option.getAdapter = function (sylApi) {
        adapter = sylApi;
    };
    react_dom_1.default.render([react_1.default.createElement(SylWrapper, __assign({ key: "syl-editor" }, option))], el);
    return {
        getAdapter: function () { return adapter; },
        change: function (newOption) {
            option = Object.assign(option, getOption(newOption));
            react_dom_1.default.render([react_1.default.createElement(SylWrapper, __assign({ key: "syl-editor" }, option))], el);
        },
        unmount: function () {
            react_dom_1.default.unmountComponentAtNode(el);
        }
    };
}
exports.render = render;
var pluginProps = {
    code_block: {
        controllerProps: {
            lineNumbers: false
        }
    },
    letter_space: {
        controllerProps: {
            allowedValues: [0, 0.5, 1, 1.5]
        }
    },
    font_size: {
        controllerProps: {
            allowedValues: [12, 14, 16, { value: 17, default: true }, 18, 20, 24, 32],
            values: [12, 14, 16, { value: 17, default: true }, 18, 20, 24, 32],
            unit: 'px'
        }
    },
    image: {
        layers: {
            test: function () { return react_1.default.createElement("span", null, " test "); }
        },
        controllerProps: {
            uploader: function (f) {
                console.log('uploading image');
                return Promise.resolve('');
            },
            uploadMaxWidth: 440,
            disableAlign: false,
            addAttributes: {
                duck: {
                    default: '',
                    setDOMAttr: function (value, attrs) {
                        attrs.duck = value;
                    },
                    getFromDOM: function (dom) { return dom.getAttribute('duck') || false; }
                }
            }
            // disableCaption: true
        }
    },
    link: {
        controllerProps: {
            validateHref: function (href) {
                console.log('validate link');
                if (href.includes('http')) {
                    return {
                        error: false,
                        href: href
                    };
                }
                else {
                    return {
                        error: true,
                        text: '出错了',
                        href: href
                    };
                }
            }
        }
    },
    video: {
        controllerProps: {
            uploader: function (file, editor) {
                console.log('uploading video');
                return Promise.resolve({
                    src: URL.createObjectURL(file)
                });
            },
            addAttributes: {
                duck: {
                    default: '',
                    setDOMAttr: function (value, attrs) {
                        attrs.duck = value;
                    },
                    getFromDOM: function (dom) { return dom.getAttribute('duck') || false; }
                }
            }
        }
    },
    /**
     * * <p style="line-height: 3; margin: 10px 6px 12px 6px;text-align: center;" class="syl">123</p>
     * * <p style="text-align: center;margin: 16px 8px 12px;" class="syl">123</p>
     */
    paragraph: {
        controllerProps: {
            addMatchTags: ['section'],
            allowedAligns: ['left', 'center', 'right', 'justify'],
            allowedClass: [],
            allowedLineHeights: false,
            allowedLineIndents: [],
            allowedSpaceBefores: [4, { default: true, value: 8 }, 16],
            allowedSpaceAfters: { default: true, value: 20 },
            allowedSpaceBoths: [4, 8, 16]
        }
    },
    list_item: {
        controllerProps: {
            matchInnerTags: ['section', 'p'],
            allowedLineHeights: [],
            allowedLineIndents: [],
            allowedSpaceBefores: [4, { default: true, value: 8 }, 16],
            allowedSpaceAfters: { default: true, value: 20 },
            allowedSpaceBoths: [4, 8, 16],
            maxNestedLevel: 1
        }
    },
    audio: {
        controllerProps: {
            uploader: function (file) { return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    return [2 /*return*/, Promise.resolve({
                            src: URL.createObjectURL(file),
                            size: file.size,
                            type: file.type,
                            title: file.name
                        })];
                });
            }); },
            addAttributes: {
                duck: {
                    default: '',
                    setDOMAttr: function (value, attrs) {
                        attrs.duck = value;
                    },
                    getFromDOM: function (dom) { return dom.getAttribute('duck') || false; }
                }
            }
        }
    }
};
var addConfigs = function (name, plugin, extraConfig) {
    if (extraConfig === void 0) { extraConfig = {}; }
    var prop = extraConfig[name] || pluginProps[name];
    if (prop) {
        return __assign({ plugin: plugin }, prop);
    }
    return plugin;
};
function getSylPlugins(config) {
    if (config === void 0) { config = {}; }
    return Object.keys(main_1.plugins)
        .map(function (key) {
        var Format = addConfigs(key, main_1.plugins[key], config);
        return Format || false;
    })
        .filter(Boolean);
}
function getModulesOption(_a) {
    var toolbar = _a.toolbar, thesis = _a.thesis;
    if (toolbar) {
        return {
            toolbar: {
                Ctor: toolbar_loader_1.ToolbarLoader,
                option: {
                    Component: toolbar.Component || toolbar_1.Toolbar,
                    tools: toolbar.tools || [],
                    tooltips: toolbar.tooltips,
                    icons: toolbar.icons,
                    mount: toolbar.mount,
                    utils: toolbar.utils,
                    showNames: toolbar.showNames,
                    className: toolbar.className || 'syl-toolbar'
                }
            },
            toolbarInline: {
                Ctor: toolbar_loader_2.ToolbarInlineLoader,
                option: {
                    tools: [
                        'bold',
                        'font_size',
                        'underline',
                        'strike',
                        'italic',
                        '|',
                        'align_left',
                        'header',
                        {
                            content: ['ordered_list', 'bullet_list'],
                            contentOption: { tipDirection: 'up' }
                        },
                        'color'
                    ],
                    Component: inline_1.ToolbarInline,
                    utils: {
                        align_left: lib_1.AlignLeftUtil
                    }
                }
            }
        };
    }
    else {
        return {};
    }
}
__export(require("./main"));
//# sourceMappingURL=render.js.map